import {ICharTalent} from "../_interfaces/ICharTalent";
import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_talents} from "../_signals/s_char";

export const TalentsCreate = (talents: ICharTalent[]) => {
    fetch(apiAddress + "/char/talents/", createOptions('CREATE', talents))
        .then((res) => res.json())
        .then((data) => console.log('BETalents create response', data))
        .catch((reason => console.log('BETalents create catch', reason)))
}

export const TalentsAdd = (talents: ICharTalent[]) => {
    fetch(apiAddress + "/char/talents/", createOptions('CREATE', talents))
        .then((res) => res.json())
        .then((data) => console.log('BETalents create response', data))
        .catch((reason => console.log('BETalents create catch', reason)))
}

export const TalentsUpdate = (talents: ICharTalent[]) => {
    fetch(apiAddress + "/char/talents/", createOptions('UPDATE', talents))
        .then((res) => res.json())
        .then((data) => console.log('BETalents update response', data))
        .catch((reason => console.log('BETalents update catch', reason)))
}

export const TalentsGet = (cid:string) => {
    fetch(apiAddress + "/char/talents/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BETalents get response', data.result);
                    s_char_talents.value = (data.result as ICharTalent[])
                }
            }
        )
        .catch((reason => {
            console.log('BETalents get catch', reason);
        }))
}